var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckmark = function SvgCheckmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13.7500086px",
    height: "11.2500112px",
    viewBox: "0 0 13.7500086 11.2500112",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.4.0-Health-screening-/-Upcoming-/-Reschedule-/-Step-2",
    transform: "translate(-383.125000, -151.374991)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-new-appointment-/-Step-1",
    transform: "translate(256.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Number",
    transform: "translate(118.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7796396,6.58843459 C18.0069409,6.3286617 18.4017925,6.30233825 18.6615654,6.52963954 C18.9213383,6.75694082 18.9476618,7.15179246 18.7203605,7.41156536 L9.97036042,17.4115654 C9.73228462,17.683652 9.31370569,17.6975892 9.05805825,17.4419418 L5.30805823,13.6919417 C5.06398054,13.4478641 5.06398054,13.0521359 5.30805823,12.8080583 C5.55213591,12.5639806 5.94786403,12.5639806 6.19194171,12.8080583 L9.46953124,16.0856641 L17.7796396,6.58843459 Z",
    id: "checkmark"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark.b3e5c1ed.svg";
export { ForwardRef as ReactComponent };